require('./bootstrap');

require('floatthead/dist/jquery.floatThead');

require('dropzone/dist/dropzone');

require('bootstrap-autocomplete/dist/latest/bootstrap-autocomplete.min');
